export const sortByDate = <T extends { createdAt: string }>({
  data,
  order = 'asc'
}: {
  data: T[];
  order?: 'asc' | 'desc';
}) => {
  const directionMultiplier = order === 'asc' ? 1 : -1;
  return data.sort((a, b) => (new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()) * directionMultiplier);
};

/** Natural sort: "1", "2", "10" instead of lexicographic "1", "10", "2". */
const naturalCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

export const compareNatural = (a: string, b: string) => naturalCollator.compare(a, b);

export const sortByNameNatural = <T extends { name: string }>(items: readonly T[]): T[] =>
  [...items].sort((a, b) => compareNatural(a.name, b.name));
